/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectionStrategy, Component, DestroyRef, Input, OnInit, inject} from '@angular/core';

import template from './line-item-template-list-page.component.html';
import {SignalAdminListColumn, SignalAdminResourceListStateFactory} from '../common/controller/signal-admin-resource-list-state';
import {LineItemBulkActionService} from './line-item-bulk-action.service';
import {LocalUserPermissions} from '../../components/session/local-user-permissions';
import {LineItemModel} from './line-item-api.service';
import {LineItemTemplateApiService} from './line-item-template-api.service';

@Component({
  standalone: false,
  selector: 'adn-line-item-template-list-page',
  template,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LineItemTemplateListPageComponent implements OnInit {
  // Absolute state (March used relative ".line-item-template" from the list).
  readonly itemStateName = 'app.adv.line-item-templates.line-item-template';
  readonly tierItemStateName = 'app.adm.tiers.tier';

  readonly columns: SignalAdminListColumn[] = [
    {param: 'name'},
    {param: 'Tier', label: 'tier'},
    {param: 'objectives', numeric: true},
    {param: '', label: 'targeting', sortable: false}
  ];

  readonly list = inject(SignalAdminResourceListStateFactory).create<LineItemModel>(
    inject(LineItemTemplateApiService),
    {listId: 'fullLineItemTemplateList', baseTable: 'lineItemTemplate'},
    inject(DestroyRef)
  );

  private readonly permissions = inject(LocalUserPermissions);
  private readonly api = inject(LineItemTemplateApiService);
  private readonly lineItemBulkActionService = inject(LineItemBulkActionService);

  @Input()
  set readOnly(value: boolean) {
    this.list.readOnly.set(value);
  }

  systemLinkDisabled(): boolean {
    return this.permissions.getAllVisPermissions().MANAGE_SYSTEM !== true;
  }

  ngOnInit(): void {
    this.list.load();
  }

  openBulkActions(): void {
    this.lineItemBulkActionService.createBulkAction({
      bulkSelection: this.list.selected(),
      miscBulkAction: (modal: any, controller: any, items: Partial<LineItemModel>[], _resource: any, params: any) => {
        this.api.bulkSave(params || {}, items).subscribe({
          next: () => {
            modal.close();
            this.list.deselectAll();
            this.list.load();
          },
          error: () => {
            controller.form = controller.form || {};
            controller.form.bulkError = true;
          }
        });
      }
    })();
  }
}
